import type { ThemeConfig } from 'antd';

export const DM_COLOR = '#7171EE'; // DeepMiner 主色

export const theme: ThemeConfig = {
  token: {
    colorPrimary: DM_COLOR,
    colorInfo: DM_COLOR,
    colorSuccess: DM_COLOR,
  },
  components: {
    Button: {
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      borderRadiusXS: 4,
      contentFontSizeLG: 14,
      contentLineHeightSM: 14,
      contentFontSizeSM: 12,
      paddingInline: 20,
      paddingInlineLG: 20,
      paddingInlineSM: 8,
    },
    Modal: {
      borderRadius: 12,
    },
    Input: {
      borderRadius: 8,
    },
  },
};
